import React from 'react';

export const BookmarkCheckedSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4 6a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v12.942c0 1.67-1.923 2.604-3.236 1.573L12 16.772l-4.764 3.743C5.923 21.546 4 20.611 4 18.942z"
            clipRule="evenodd"
        />
    </svg>
);
